"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _vue = _interopRequireDefault(require("vue"));

var _vueHighlightjs = _interopRequireDefault(require("vue-highlightjs"));

require("highlight.js/styles/atom-one-dark.css");

var _crud = _interopRequireDefault(require("@/mixins/crud"));

var _DateRangePicker = _interopRequireDefault(require("@/components/DateRangePicker"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
_vue.default.use(_vueHighlightjs.default);

var _default = {
  components: {
    DateRangePicker: _DateRangePicker.default
  },
  mixins: [_crud.default],
  data: function data() {
    return {
      title: '任务日志',
      errorInfo: '',
      errorDialog: false,
      enabledTypeOptions: [{
        key: 'true',
        display_name: '成功'
      }, {
        key: 'false',
        display_name: '失败'
      }]
    };
  },
  methods: {
    doInit: function doInit() {
      var _this = this;

      this.$nextTick(function () {
        _this.init();
      });
    },
    // 获取数据前设置好接口地址
    beforeInit: function beforeInit() {
      this.url = 'api/jobs/logs';
      this.size = 6;
      return true;
    },
    // 异常详情
    info: function info(errorInfo) {
      this.errorInfo = errorInfo;
      this.errorDialog = true;
    }
  }
};
exports.default = _default;